module.exports = __webpack_public_path__ + "login.07cea5ab433ade274b19.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/login/login.png
// module id = ../../../../../src/assets/layout/images/login/login.png
// module chunks = 2